import React, { useEffect, useState } from 'react';
import { Container, Wrapper } from './authenticationSteps.style';
import ProgressBarCarousal from '../../components/ProgressBarCarousal';
import { useMediaQuery } from '@mui/material';
import ResponsiveAuthenticationSteps from '../ResponsiveAuthenticationSteps';
import PropTypes from 'prop-types';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);

const AuthenticationSteps = ({ HeadingComponent, steps = [] }) => {
    const isSmallScreen = useMediaQuery('(max-width: 600px)');
    const [hydrated, setHydrated] = useState(false);

    useEffect(() => {
        setHydrated(true);
    }, []);

    if (!hydrated) {
        return null;
    }
    return (
        <Wrapper>
            <Container>
                {HeadingComponent}
                {isSmallScreen ? (
                    <ResponsiveAuthenticationSteps items={steps} />
                ) : (
                    <ProgressBarCarousal items={steps} />
                )}
            </Container>
        </Wrapper>
    );
};

AuthenticationSteps.propTypes = {
    HeadingComponent: PropTypes.element,
    steps: PropTypes.array,
};

export default AuthenticationSteps;
